
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/story/[id]/[slug]",
      function () {
        return require("private-next-pages/story/[id]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/story/[id]/[slug]"])
      });
    }
  